module.exports = __webpack_public_path__ + "img/bugles.c8f4311d.png";